define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette      = require('marionette');
    var I18n            = require('i18n!nls/main');

    var MainTpl      = require('text!tmpls/parts/notices/main.tpl').default;
    var ItemTpl      = require('text!tmpls/parts/notices/notice_item.tpl').default;

    var EmptyView    = require('parts/rightbar_empty');
    var AppConfig       = require('config/application');
    var Model = Backbone.Model.extend({});

    var ItemView = Marionette.ItemView.extend({
        template : ItemTpl,
        model    : new Model(),
        className: 'b-mc__body scrollbar-macosx'
    });

    return Marionette.LayoutView.extend({
        template : MainTpl,
        model    : new Model(),

        regions : {
            regionCalls : '.js-region-notices'
        },

        ui : {
            'deleteNotification': '.js-delete-call',
            'collapseProject'   : '.js-collapse-project',
            'clearAll'          : '.js-clear',
            'singleProject'     : '.js-single-project',
            'allProjects'       : '.js-all-projects'
        },

        events : {
            'click @ui.deleteNotification': 'deleteNotification',
            'click @ui.collapseProject' : 'collapseProject',
            'click @ui.clearAll'        : 'clearAll',
            'click @ui.singleProject'   : 'singleProject',
            'click @ui.allProjects'     : 'allProjects',
        },

        initialize : function(){
            this.listenTo(app.Collections.Notices, 'sync', this.transform_collection);
            /**
             * if 0 we filter by all projects
             */
            this.cur_project = 0;
        },

        onRender : function(){
            this.transform_collection();
        },

        /**
         * transfer collection to array to export on template
         */
        transform_collection : function(){
            var that = this;
            var items = {}, project_id, project_name, project;

            that.collection = app.Collections.Notices;

            if(that.collection.length > 0){
                _.each(that.collection.models, function(model , i){
                    if(that.cur_project == 0){
                        project_id = model.get('project_id');
                        project = app.Collections.Projects.get( project_id );
                        project_name = project.get('name');
                    }else{
                        if(model.get('project_id') == that.cur_project){
                            project = app.Collections.Projects.get( that.cur_project );
                            project_name = project.get('name');
                        }
                    }

                    // test
                    // project_name = 'Test Frontend';

                    if(project_name !== undefined){
                        if(typeof items[project_name] == 'undefined') items[project_name] = [];

                        items[project_name].push({
                            id          : model.get('id'),
                            date        : model.get('date'),
                            description : model.get('description'),
                            title       : model.get('title')
                        });
                    }
                });

                that.model.set({ items : items });
                that.regionCalls.show( new ItemView({ model : that.model }) );
            }else{
                 that.regionCalls.show( new EmptyView() );
            }
            this.$el.lptSetter();
        },

        /**
         * removing single alert
         */
        deleteNotification : function(e){
            var that = this;
            var id = $(e.currentTarget).data('id');
            var model = app.Collections.Notices.get( id );

            Backbone.ajax({
                url: AppConfig.host + '/rest/system/header/delete',
                dataType: 'JSON',
                type : 'POST',
                data : {
                    item_id     : id,
                    item_type   : 'notification',
                },
                success: function(response){
                    if(response.status == 1 && !that.isDestroyed){
                        $(e.currentTarget).closest('.b-notice__block').addClass('animated slideOutRight');
                        app.Collections.Notices.remove( model );
                        setTimeout(function(){
                            that.transform_collection();
                        }, 1000);

                        app.Vents.trigger('notices:delete');
                    }
                },
            });
        },

        /**
         * hide or show alerts
         */
        collapseProject : function(e){
            $(e.currentTarget).children('span').toggle();
            this.$('.b-notice__block').toggle();
        },

        /**
         * remove all alerts
         */
        clearAll : function(){
            var that = this;

            Backbone.ajax({
                url: AppConfig.host + '/rest/system/header/delete/notifications',
                dataType: 'JSON',
                type : 'POST',
                data : {
                    item_id     : app.Collections.Notices.toJSON(),
                    item_type   : 'notification'
                },
                success: function(response){
                    if(response.status == 1 && !that.isDestroyed){
                        that.$('.b-mc__body').addClass('animated fadeOutRight');

                        setTimeout(function(){
                            app.message.success('Список оповещений очищен.');
                            app.Collections.Notices.reset();
                            that.transform_collection();
                        }, 1000);
                        app.Vents.trigger('notices:delete');
                    }
                },
            });
        },

        /**
         * filter by all projects
         */
        allProjects : function(){
            this.$('.js-all-projects').addClass('active');
            this.$('.js-single-project').removeClass('active');

            this.cur_project = 0;

            this.transform_collection();
        },

        /**
         * filter by single project
         */
        singleProject : function(){
            this.$('.js-single-project').addClass('active');
            this.$('.js-all-projects').removeClass('active');

            this.cur_project = app.Models.curProject.get('id');

            this.transform_collection();
        }

    });
});
